module.exports = __webpack_public_path__ + "media/images/vip-background-33e0e9f6812a632ac6f0398460be1575.png";